import React from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import { rhTierRewards, rhGeneral, rhAnalytics, } from '../../../../constants/RewardsHub';
import { DrawerContext, InfoPerksContext, InfoRewardsContext, } from '../../../../contexts';
import { analyticsStash } from '../../../../utils/analytics';
import { usePxccDetailsModal } from '../../../RewardsHub/TierBenefits/PerkRewards/PLCCDetailsModal';
import { DrawerEventTriggers } from '../../../../utils/DrawerEventUtils';
import { newrelic, REWARDS_HUB_PERK_OPTIONS_VIEW, REWARDS_HUB_PERK_HISTORY_VIEW, REWARDS_HUB_PERKS_LIST_VIEW, REWARDS_HUB_OFFERS_LIST_VIEW, REWARDS_HUB_PERK_PROGRESS_VIEW, } from '../../../../utils/newrelic';
var constantsPerks = rhTierRewards.perkRewards;
var constantsOffers = rhTierRewards.offerRewards;
var constantsRewards = rhTierRewards.rewards;
var RenderButton = function (_a) {
    var text = _a.text, onClick = _a.onClick, href = _a.href;
    return (React.createElement(Button, { variant: "secondary", fullWidth: true, href: href, onClick: onClick },
        React.createElement("span", { className: "sui-w-full sui-text-center sui-inline" }, text)));
};
export var ButtonTrackPerksProgress = function () { return (React.createElement(RenderButton, { text: constantsPerks.ctaTrackProgress, href: rhGeneral.perksPage, onClick: function () {
        // Track perks progress view
        newrelic.addPageAction(REWARDS_HUB_PERK_PROGRESS_VIEW, {
            result: 'success',
            buttonType: 'track_progress',
            source: 'reward_card',
            destination: 'perks_page',
        });
        analyticsStash(rhAnalytics.trackProgressButton);
    } })); };
export var ButtonViewPerkOptions = function () {
    var _a, _b, _c;
    var _d = React.useContext(DrawerContext), openSelectionPerks = _d.openSelectionPerks, onDrawerClose = _d.onDrawerClose, isPacDrawersEnabled = _d.isPacDrawersEnabled;
    var perksInfo = React.useContext(InfoPerksContext).perksInfo;
    var _e = React.useContext(InfoRewardsContext), rewardsInfo = _e.rewardsInfo, isBlendedRewardsEnabled = _e.isBlendedRewardsEnabled;
    var tempInfo = isBlendedRewardsEnabled ? rewardsInfo : perksInfo;
    var tierList = (_a = tempInfo === null || tempInfo === void 0 ? void 0 : tempInfo.program) === null || _a === void 0 ? void 0 : _a.tiers;
    var ctaText = constantsPerks.ctaViewPerkOptions;
    var _f = tempInfo || {}, currentTierId = _f.currentTierId, pxccUserCategory = _f.pxccUserCategory, accrualData = _f.accrualData, activePxccFactor = _f.activePxccFactor;
    var tierIdx = tierList === null || tierList === void 0 ? void 0 : tierList.findIndex(function (tier) { return tier.tierId === currentTierId; });
    var currentPerk = tierIdx > -1 && ((_c = (_b = tierList[tierIdx]) === null || _b === void 0 ? void 0 : _b.tierPerks) === null || _c === void 0 ? void 0 : _c[0]);
    var eventOutput = {
        tierId: currentTierId,
        tierList: tierList,
        onClose: onDrawerClose,
        accrualData: accrualData,
        pxccUserCategory: pxccUserCategory,
        activePxccFactor: activePxccFactor,
    };
    var onClick = function () {
        // Track view perk optionsview
        newrelic.addPageAction(REWARDS_HUB_PERK_OPTIONS_VIEW, {
            result: 'success',
            viewType: 'history',
            buttonType: 'view_history',
            source: 'reward_card',
            destination: 'perks_page',
        });
        if (isPacDrawersEnabled)
            DrawerEventTriggers.triggerPerkSelectionDrawer(eventOutput);
        else
            openSelectionPerks({ perk: currentPerk, eventOutput: eventOutput });
        analyticsStash(rhAnalytics.viewPerkOptions);
    };
    return (React.createElement(Button, { style: { padding: 0 }, variant: "secondary", fullWidth: true, onClick: onClick },
        React.createElement("span", { className: "sui-w-full sui-text-center sui-inline" }, ctaText)));
};
export var ButtonViewPerksHistory = function () {
    var ctaText = constantsPerks.ctaViewPerkHistory;
    return (React.createElement(Button, { style: { padding: 0 }, variant: "secondary", fullWidth: true, href: rhGeneral.perksPage, onClick: function () {
            // Track perks history view
            newrelic.addPageAction(REWARDS_HUB_PERK_HISTORY_VIEW, {
                result: 'success',
                viewType: 'history',
                buttonType: 'view_history',
                source: 'reward_card',
                destination: 'perks_page',
            });
            analyticsStash(rhAnalytics.viewPerkHistory);
        } },
        React.createElement("span", { className: "sui-w-full sui-text-center sui-inline" }, ctaText)));
};
export var ButtonShowAllPerks = function () {
    var openListPerks = React.useContext(DrawerContext).openListPerks;
    return (React.createElement(RenderButton, { text: constantsPerks.ctaShowAll, onClick: function () {
            newrelic.addPageAction(REWARDS_HUB_PERKS_LIST_VIEW, {
                result: 'success',
                buttonType: 'show_all',
                source: 'reward_card',
                drawerType: 'PerksList',
            });
            analyticsStash(rhAnalytics.showAllPerks);
            openListPerks();
        } }));
};
export var ButtonShowAllOffers = function () {
    var openListOffers = React.useContext(DrawerContext).openListOffers;
    return (React.createElement(RenderButton, { text: constantsOffers.ctaShowAll, onClick: function () {
            // Track show all offers
            newrelic.addPageAction(REWARDS_HUB_OFFERS_LIST_VIEW, {
                result: 'success',
                buttonType: 'show_all',
                source: 'reward_card',
                drawerType: 'OffersList',
            });
            analyticsStash(rhAnalytics.showAllOffers);
            openListOffers();
        } }));
};
export var ButtonShowAllRewards = function () {
    var openListRewards = React.useContext(DrawerContext).openListRewards;
    return (React.createElement(RenderButton, { text: constantsRewards.ctaShowAll, onClick: function () {
            analyticsStash(rhAnalytics.showAllOffers);
            openListRewards();
        } }));
};
export var ButtonViewCardDetails = function () {
    var _a = usePxccDetailsModal(), PxccDetailsModal = _a.PxccDetailsModal, setPLCCtoggle = _a.setPLCCtoggle;
    return (React.createElement(React.Fragment, null,
        React.createElement(PxccDetailsModal, null),
        React.createElement(RenderButton, { text: constantsPerks.ctaViewCardDetails, onClick: function () {
                analyticsStash(rhAnalytics.viewCardDetails);
                setPLCCtoggle(true);
            } })));
};
export var ButtonsTrackAndShow = function () {
    var isPacDrawersEnabled = React.useContext(DrawerContext).isPacDrawersEnabled;
    return (React.createElement("div", { className: "sui-flex sui-gap-4 sui-flex-col-reverse sui-w-full md:sui-flex-row md:sui-gap-4" },
        !isPacDrawersEnabled && React.createElement(ButtonTrackPerksProgress, null),
        React.createElement(ButtonShowAllPerks, null)));
};
export var ButtonsTrackAndDetails = function () {
    var isPacDrawersEnabled = React.useContext(DrawerContext).isPacDrawersEnabled;
    return (React.createElement("div", { className: "sui-flex sui-gap-4 sui-flex-col-reverse sui-w-full md:sui-flex-row md:sui-gap-4" },
        !isPacDrawersEnabled && React.createElement(ButtonTrackPerksProgress, null),
        React.createElement(ButtonViewCardDetails, null)));
};
export var ButtonPostAJob = function () {
    return (React.createElement(Button, { variant: "secondary", fullWidth: true, href: "/auth/view/signin?redirect=/path-to-pro-network/job-postings/" },
        React.createElement("span", { className: "sui-w-full sui-text-center" }, "Post A Job")));
};
export var ButtonHireTradesPeople = function () {
    return (React.createElement(Button, { variant: "secondary", fullWidth: true, href: "/auth/view/signin?redirect=/path-to-pro-network/search" },
        React.createElement("span", { className: "sui-w-full sui-text-center" }, "Hire Tradespeople")));
};
